import React, { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';

type PaymentAuthenticationModalProps = {
  open: boolean;
  onClose: () => void;
  isPolling: boolean;
};

const PaymentAuthenticationModal: FC<PaymentAuthenticationModalProps> = ({
  open,
  onClose,
  isPolling,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    disableEscapeKeyDown={isPolling}
  >
    <DialogTitle sx={{ paddingBottom: 1 }}>
      Bank Authentication Required
    </DialogTitle>
    <Divider />
    <DialogContent sx={{ paddingTop: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {isPolling && <CircularProgress size={40} sx={{ color: '#004C56' }} />}
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          Please complete the authentication in your bank app to finish setting
          up your payment method.
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'textSecondary', textAlign: 'center' }}
        >
          We&apos;re waiting for your authentication to complete...
        </Typography>
      </Box>
    </DialogContent>
    <Divider />
    <DialogActions sx={{ padding: 2 }}>
      <Button
        onClick={onClose}
        variant="outlined"
        fullWidth
        disabled={isPolling}
      >
        {isPolling ? 'Waiting...' : 'Close'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default PaymentAuthenticationModal;
